import { render, staticRenderFns } from "./VPopup.vue?vue&type=template&id=cc6b8004&"
import script from "./VPopup.vue?vue&type=script&lang=js&"
export * from "./VPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports